class SubControls extends HTMLElement {
    connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('article'));

        if (!this.cards.length) return;

        this.initAnimations();
    }

    initAnimations() {
        this.cards.forEach((card, index) => {
            if (index === 0) return;

            const previousCard = this.cards[index - 1];

            gsap.timeline({
                scrollTrigger: {
                    trigger: card,
                    start: 'top 80%',
                    end: 'top top',
                    scrub: true,

                },

            })
                .to(previousCard, {
                    scale: 0.8,
                    opacity: 0,
                    ease: 'none',

                });
        });
    }
}

customElements.define('sub-controls', SubControls);